module.exports = __webpack_public_path__ + "img/service2-1.f6585264.webp";